<script setup>
// Affichage de la demande `useConfirm` en cours. Monte une seule fois dans
// App.vue : ne rend rien tant qu'aucune confirmation n'est demandee.
import BaseModal from './BaseModal.vue';
import { useConfirm } from '../composables/useConfirm';

const { pending, accept, cancel } = useConfirm();
</script>

<template>
  <BaseModal :isOpen="!!pending" :title="pending?.title || ''" maxWidth="max-w-sm w-full mx-4" @close="cancel">
    <div class="p-5">
      <p class="text-sm text-gray-700 leading-relaxed whitespace-pre-line">{{ pending?.message }}</p>
    </div>
    <template #footer>
      <div class="flex gap-2 justify-end">
        <button type="button" @click="cancel"
                class="px-4 py-2.5 rounded-xl border border-gray-200 text-gray-600 font-bold text-sm hover:bg-gray-50 active:scale-95 transition-all">
          {{ pending?.cancelLabel }}
        </button>
        <button type="button" @click="accept"
                :class="['px-4 py-2.5 rounded-xl font-bold text-sm shadow-sm active:scale-95 transition-all', pending?.danger ? 'bg-red-500 hover:bg-red-600 text-white' : 'bg-[#ffd93e] hover:bg-[#ffcf0f] text-[#111]']">
          {{ pending?.confirmLabel }}
        </button>
      </div>
    </template>
  </BaseModal>
</template>
